<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1"><span style="color: #2AD3DA">{{ data1['price']}}</span></div>
        <div class="data2"><span style="color: #2AD3DA">{{ data2['price'] }}</span></div>
        <div class="data3"><span style="color: #2AD3DA">{{ data3['price'] }}</span></div>
        <div class="data4"><span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5"><span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6"><span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7"><span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8"><span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write"
               :class="{'title-write-red' : industryFlag===56}">新闻资讯
          </div>
          <span class="title-more fr" @click="toTwoPage('/styrene/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryListOne" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/styrene/industry', item.id)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position:relative;">
          <img style="margin-bottom: -7px;" src="../../assets/ironstone/jiage.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #222222;line-height: 33px;">
            价格</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer"
                @click="toTwoPage('/styrene/twoPage/price', 'issue_styrene_price')"> >></span>
          <div class="classification-content">
            <div class="classification-content-div price" v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/styrene/price', item.completeOriginalDate, 'issue_styrene_price')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '苯乙烯价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/home/jineixiananchanliang.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #fff;line-height: 33px;">
            产量</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer;color:#fff"
                @click="toTwoPage('/styrene/twoPage/yield')"> >></span>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/styrene/yield', item.id)">
              <i></i>
              <p>{{ item.titleName}}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/styrene/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/styrene/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/styrene/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/styrene/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口'" :flag="false" :unit="false"
                                :params="{title:'进出口',typeList:['总量', '按国家']}"
                                :url="'/styrene/twoPage/exit'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="exitFlag = 'issue_styrene_exit_total'"
                @click="toTwoPage('/styrene/twoPage/exit', 'issue_styrene_exit_total')"
                :class="{'stockFlag':exitFlag === 'issue_styrene_exit_total'}">总量</span>
          <span class="classification-tabs-two" @mouseover="exitFlag = 'issue_styrene_exit_country'"
                @click="toTwoPage('/styrene/twoPage/exit', 'issue_styrene_exit_country')"
                :class="{'stockFlag':exitFlag === 'issue_styrene_exit_country'}">按国家</span>
          <div class="classification-content" style="margin-top: 4px" v-if="exitFlag === 'issue_styrene_exit_total'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in exitOneList" :key="index"
                 @click="goDetail('/styrene/exit', item.completeOriginalDate, 'issue_styrene_exit_total')">
              <i></i>
              <p>{{ item.date + '苯乙烯进出口量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="exitFlag === 'issue_styrene_exit_country'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in exitTwoList" :key="index"
                 @click="goDetail('/styrene/exit', item.completeOriginalDate, 'issue_styrene_exit_country')">
              <i></i>
              <p>{{ item.date + '苯乙烯进出口量(按国家)' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="false" :unit="false"
                                :url="'/styrene/twoPage/stock'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in stockList" :key="index"
                 @click="goDetail('/styrene/stock', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '苯乙烯库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/styrene/map')" alt="">
<!--            <Expect :marginTop="'40px'"></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'利润'" :flag="false" :unit="false"
                                :url="'/styrene/twoPage/profit'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in profitList" :key="index"
                 @click="goDetail('/styrene/profit', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'开工率'" :flag="false" :unit="false"
                                :url="'/styrene/twoPage/rate'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in rateList" :key="index"
                 @click="goDetail('/styrene/rate', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '苯乙烯开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
<!--        <li>-->
<!--          <img src="../../assets/methanol/dashuju.png" alt="">-->
<!--          <div class="classification-content">-->
<!--            <Expect></Expect>-->
<!--          </div>-->
<!--        </li>-->
        <li>
          <ClassificationHeader :name="'装置动态'" :flag="false" :unit="false"
                                :url="'/styrene/twoPage/device'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in deviceList" :key="index"
                 @click="goDetail('/styrene/device', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'塑料'" :flag="false" :unit="false"
                                :params="{title:'塑料',typeList:['价格及利润', '产量', 'ABS/EPS开工率', 'PS开工率']}"
                                :url="'/styrene/twoPage/plastics'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="plasticsFlag = 'issue_styrene_profit'"
                @click="toTwoPage('/styrene/twoPage/plastics', 'issue_styrene_profit')"
                style="font-size: 12px"
                :class="{'stockFlag':plasticsFlag === 'issue_styrene_profit'}">价格及利润</span>
          <span class="classification-tabs-three" @mouseover="plasticsFlag = 38"
                @click="toTwoPage('/styrene/twoPage/plastics', 38)"
                style="font-size: 12px"
                :class="{'stockFlag':plasticsFlag === 38}">产量</span>
          <span class="classification-tabs-three" @mouseover="plasticsFlag = 'issue_styrene_letter'"
                @click="toTwoPage('/styrene/twoPage/plastics', 'issue_styrene_letter')"
                style="font-size: 12px"
                :class="{'stockFlag':plasticsFlag === 'issue_styrene_letter'}">ABS/EPS开工率</span>
          <span class="classification-tabs-three" @mouseover="plasticsFlag = 37"
                @click="toTwoPage('/styrene/twoPage/plastics', 37)"
                style="font-size: 12px"
                :class="{'stockFlag':plasticsFlag === 37}">PS开工率</span>
          <div class="classification-content" style="margin-top: 4px" v-if="plasticsFlag === 'issue_styrene_profit'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in plasticsOneList" :key="index"
                 @click="goDetail('/styrene/stringProfit', item.completeOriginalDate, 'issue_styrene_profit')">
              <i></i>
              <p>{{ item.date + '塑料价格及利润' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="plasticsFlag === 38">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in plasticsTwoList" :key="index"
                 @click="goDetail('/styrene/numberProfit', item.id, 38)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="plasticsFlag === 'issue_styrene_letter'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in plasticsThreeList" :key="index"
                 @click="goDetail('/styrene/stringProfit', item.completeOriginalDate, 'issue_styrene_letter')">
              <i></i>
              <p>{{ item.date + '塑料ABS/EPS开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="plasticsFlag === 37">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in plasticsFourList" :key="index"
                 @click="goDetail('/styrene/numberProfit', item.id, 37)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative;">
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/styrene/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="exitClass">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="industrialFlag">
      <StyreneIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2"
                            :data3="data3" :data4="data4" :data5="data5" :data6="data6" :data7="data7" :data8="data8"
                            @closeIndustrialCh="closeIndustrial"></StyreneIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  industryDetail,
  reportNoAuthList,
  reportDetail,
  standardDetail,
  priceNoAuthList,
  exitNoAuthList,
  stockNoAuthList,
  chainList, rateNoAuthList
} from '@/api/styrene'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import StyreneIndustrial from '@/components/bigChart/styreneIndustrial'

export default {
  name: "index",
  components: {
    ClassificationHeader,
    Expect,
    StyreneIndustrial,
  },
  data() {
    return {
      // 行业动态
      industryFlag:56,
      industryListOne: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceOneList: [],
      // 进出口
      exitFlag: 'issue_styrene_exit_total',
      exitOneList: [],
      exitTwoList: [],
      // 库存
      stockList: [],
      // 企业动态
      dynamicList:[],
      // 塑料
      plasticsFlag: 'issue_styrene_profit',
      plasticsOneList: [],
      plasticsTwoList: [],
      plasticsThreeList:[],
      plasticsFourList:[],
      // 产量
      yieldList: [],
      // 利润
      profitList:[],
      // 行业标准
      standardList: [],
      // 装置动态
      deviceList: [],
      // 开工率
      rateList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      data9: {},
      data10: {},
      data11: {},
      data12: {},
      data13: {},
      data14: {},
      chainPrice: {},
      // 重点企业资讯
      enterpriseList: [],
      industrialFlag: false,
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_styrene_chain', styreneFlag: true}).then(res => {
        this.chainTitle = res.data['titleTime'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 56}).then(res => {
        this.industryListOne = res.rows;
      })
      // 价格
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_styrene_price',
        dataType:1,
      }).then(res => {
        this.priceOneList = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 技术及标准
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 9, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
      // 进出口
      exitNoAuthList({pageNum:1, pageSize:7, dictDataType: 'issue_styrene_exit_total'}).then(res => {
        this.exitOneList = res.rows
      })
      exitNoAuthList({pageNum:1, pageSize:7, dictDataType: 'issue_styrene_exit_country'}).then(res => {
        this.exitTwoList = res.rows
      })
      // 产量
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 55}).then(res => {
        this.yieldList = res.rows;
      })
      // 利润
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 54}).then(res => {
        this.profitList = res.rows;
      })
      // 装置动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 34}).then(res => {
        this.deviceList = res.rows;
      })
      // 开工率
      rateNoAuthList({pageNum:1, pageSize:8, dictDataType: 'issue_styrene_rate'}).then(res => {
        this.rateList = res.rows;
      })
      // 塑料
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_styrene_profit'}).then(res => {
        this.plasticsOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 38}).then(res => {
        this.plasticsTwoList = res.rows;
      })
      rateNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_styrene_letter'}).then(res => {
        this.plasticsThreeList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 37}).then(res => {
        this.plasticsFourList = res.rows;
      })
      // 库存
      stockNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: 'issue_styrene_stock'
      }).then(res => {
        this.stockList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['苯乙烯', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['苯乙烯', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id, flag}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/home/benyixichanyelian.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 21px;
      left: 273px;
    }

    .data1 {
      font-size: 12px;
      position: absolute;
      top: 169px;
      left: 16px;
      width: 97px;
      height: 50px;
      text-align: center;
    }

    .data2 {
      font-size: 12px;
      position: absolute;
      top: 161px;
      left: 116px;
      width: 97px;
      height: 50px;
      text-align: center;
    }

    .data3 {
      font-size: 12px;
      position: absolute;
      top: 161px;
      left: 206px;
      text-align: center;
      width: 106px;
      height: 50px;
    }

    .data4 {
      font-size: 12px;
      position: absolute;
      top: 291px;
      left: 207px;
      width: 106px;
      text-align: center;
      height: 50px;
    }

    .data5 {
      font-size: 12px;
      position: absolute;
      top: 223px;
      left: 358px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 129px;
      left: 530px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 196px;
      left: 530px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 259px;
      left: 526px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .differPrice1 {
      position: absolute;
      top: 249px;
      left: 307px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 98px;
      left: 485px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 169px;
      left: 485px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 240px;
      left: 487px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 186px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        //background-color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}

.head {
  color: #222222;
  height: 35px;
  line-height: 30px;
  position: relative;
  border-bottom: 2px solid #ccc;

  i {
    width: 60px;
    height: 2px;
    background: #CCCCCC;
    display: inline-block;
    position: absolute;
    bottom: 0;
  }

  em {
    width: 4px;
    height: 18px;
    background: #D3131A;
    font-style: normal;
    display: inline-block;
    margin-right: 9px;
    vertical-align: middle;
  }

  p {
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
  }

  .unit {
    color: #999999;
    margin-left: 10px;
    display: inline-block;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    cursor: pointer;
    height: 20px;
    border-bottom: 1px solid #fff;
  }

  span:hover {
    border-bottom: 1px solid #222;
  }
}
</style>
